import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AdminContext = createContext(null);
const STORAGE_KEY = "stealodeal_admin_token_v1";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminProvider = ({ children }) => {
  const [token, setToken] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || ""; } catch { return ""; }
  });
  const [authed, setAuthed] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const verify = async () => {
      if (!token) { setAuthed(false); setChecking(false); return; }
      try {
        await axios.post(`${API}/admin/auth/check`, {}, { headers: { "X-Admin-Token": token } });
        if (!cancelled) setAuthed(true);
      } catch {
        if (!cancelled) { setAuthed(false); setToken(""); localStorage.removeItem(STORAGE_KEY); }
      } finally {
        if (!cancelled) setChecking(false);
      }
    };
    verify();
    return () => { cancelled = true; };
  }, [token]);

  const login = (newToken) => {
    setToken(newToken);
    try { localStorage.setItem(STORAGE_KEY, newToken); } catch { /* ignore */ }
  };

  const logout = () => {
    setToken("");
    setAuthed(false);
    try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
  };

  const api = axios.create({ baseURL: API, headers: token ? { "X-Admin-Token": token } : {} });

  return (
    <AdminContext.Provider value={{ token, authed, checking, login, logout, api }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
